/**
 * Transport bounds shared by the two sign-in paths.
 *
 * Separate from `loginFailure.ts`, which is about wording an outcome: this is
 * about how long we wait for one.
 */

/**
 * How long either sign-in path waits for the backend before giving up.
 *
 * The shared axios instance sets no timeout, so its default is "wait forever".
 * For most of this app that is the right default -- a list query over a large
 * table or a worker-log download can legitimately take a long time, and a
 * global timeout would start cutting those off. A sign-in is the opposite
 * case: it is one bcrypt comparison and one token signature, it is the first
 * thing a user does, and there is nothing on screen behind it. When the
 * backend is down, "wait forever" is what turns a failure into a page that
 * sits there looking idle until the browser gives up minutes later -- which is
 * the symptom reported in issue #1196.
 *
 * Both paths need it, and the SSO one needs it most: the callback is the OIDC
 * redirect target, so a request that never settles leaves the user reading
 * "Authenticating..." with no way for the component to report anything.
 *
 * Scoped to these two requests rather than made the instance default, so the
 * blast radius is the sign-in calls and nothing else.
 */
export const LOGIN_TIMEOUT_MS = 15_000;
